export const ErrorHandling = (e: ErrorCallback) => {
    if (import.meta.env.DEV) {
        console.log(e);
    }
    throw new Error("Can't load module");
};
